import { Component, Inject, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { FormControl, FormGroup } from '@angular/forms';
import { DataInput } from '@trivelope/triv-ui-tools-lib';
import { Environment } from '../../classes/environment';
import { format } from 'date-fns';
import { debounceTime, tap } from 'rxjs';
import { UserService } from '../../services/user.service';
import { User } from '../../classes/user';

@Component({
  selector: 'app-gut-beraten',
  templateUrl: './gut-beraten.component.html',
  styleUrls: ['./gut-beraten.component.css']
})
export class GutBeratenComponent implements OnInit {

  @Input() user: User;
  myInputs: DataInput[] = [];
  datumShowed = false;
  vvId = new DataInput();
  isAccepted = new DataInput();
  date = new DataInput();
  formG1: FormGroup;

  gutBeratenLabel = '';

  accepted = false;
  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    @Inject('environment') private environment: Environment,
    @Inject('LOCALSTORAGE') private localStorage: Storage
  ) {
    this.user = this.authenticationService.getCurrentUser();
    this.formG1 = new FormGroup({});
  }

  ngOnInit(): void {
    this.initializeForm();
    this.subscribeToFormChanges();

    this.gutBeratenLabel = this.environment.texts.gutBeraten.label;

  }

  private initializeForm(): void {
    this.accepted = this.user.ebeVVIDBedingung;

    this.vvId = this.createDataInput(
      'vvId',
      'text',
      'Meine VV-ID bei der Weiterbildungsdatenbank ist',
      this.user.ebeVVID,
      false
    );

    this.isAccepted = this.createDataInput(
      'termAccepted',
      'check',
      'Ich akzeptiere die folgenden Bedingungen:',
      this.user.ebeVVIDBedingung ? true : false,
      !this.user.ebeVVID || this.user.ebeVVIDBedingung
    );

    this.myInputs.push(this.vvId);
    this.myInputs.push(this.isAccepted);

    if (this.user.ebeVVIDDatum) {
      this.date = this.createDataInput(
        'date',
        'date',
        'Datum der Akzeptierung',
        format(new Date(Number(this.user.ebeVVIDDatum)), 'yyyy-MM-dd'),
        true
      );
      this.myInputs.push(this.date);
      this.datumShowed = true;
    }
  }

  private createDataInput(
    id: string,
    type: string,
    label: string,
    defaultValue: any,
    disabled: boolean
  ): DataInput {
    const dataInput = new DataInput();
    dataInput.id = id;
    dataInput.type = type;
    dataInput.label = label;
    dataInput.defaultValue = defaultValue;
    dataInput.disabled = disabled;
    return dataInput;
  }

  private subscribeToFormChanges(): void {
    this.formG1.valueChanges.pipe(
      debounceTime(500),
      tap((value) => {
        if (!value.vvId) {
          this.formG1.get('termAccepted')?.disable();
          return;
        }

        if (value.vvId !== this.user.ebeVVID || value.termAccepted) {
          this.user.ebeVVID = value.vvId;
          if (!this.user.ebeVVIDBedingung) {
            this.user.ebeVVIDBedingung = value.termAccepted ;
            if(this.user.ebeVVID){
              this.formG1.get('termAccepted')?.enable();
            }
            if (value.termAccepted) {
              this.formG1.get('termAccepted')?.disable();
              this.user.ebeVVIDDatum = new Date().getTime().toString();
            }
          } else {
            this.user.ebeVVIDBedingung = true;
            this.formG1.get('termAccepted')?.disable();
          }

          if (value.termAccepted && !this.datumShowed) {
            this.date = this.createDataInput(
              'date',
              'date',
              'Datum der Akzeptierung',
              format(new Date(), 'yyyy-MM-dd'),
              true
            );
            this.myInputs.push(this.date);
            this.datumShowed = true;
            this.user.ebeVVIDDatum = new Date().getTime().toString();
          }

          this.userService.updateGutBeraten(this.user).subscribe((user: User) => {
            if (user && user.ebeId && !this.datumShowed && user.ebeVVIDDatum) {
              this.date = this.createDataInput(
                'date',
                'date',
                'Datum der Akzeptierung',
                format(new Date(Number(user.ebeVVIDDatum)), 'yyyy-MM-dd'),
                true
              );
              this.myInputs.push(this.date);
              this.datumShowed = true;
            }
            this.updateLocalStorageUser(this.user);
          });
        }
      })
    ).subscribe();
  }

  private updateLocalStorageUser(user: User): void {
    const strCurrentUser = JSON.stringify(user);
    this.localStorage.setItem('currentUser', strCurrentUser);
  }
}
